import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getImageDetails } from "../../../../../feature/image-slice";
import * as THREE from "three";
import LightRay from "../../../components/planet-engage/light-ray";
import { a } from "@react-spring/three";
import { Text } from "@react-three/drei";
import { splashTextConfig } from "../loading.config";

const SplashAnimation = (props: any) => {
  const { close, onCloseComplete, text } = props;
  const imageSlice = useSelector(getImageDetails);
  const lightRef = useRef<any>(null);
  const ufoRef = useRef<any>(null);
  const userRef = useRef<any>(null);
  const textRef = useRef<any>(null);
  const { viewport } = useThree();
  const [textType, setSetType] = useState<any>(text);

  const [light, setLight] = useState(true);

  const viewScale = useMemo(() => {

    return Math.min(viewport.width / 15, 1);
  }, [viewport.width]);

  const texture = useMemo(() => {
    return new THREE.TextureLoader().load(imageSlice.common[13].img);
  }, [imageSlice.common[13].img]);
  const FrameTexture = useMemo(() => {
    return new THREE.TextureLoader().load(imageSlice.frame[0].img);
  }, [imageSlice.frame[0].img]);

  const objectTexture = useMemo(() => {
    return new THREE.TextureLoader().load(imageSlice.object[0].img);
  }, [imageSlice.frame[0].img]);
  const userTexture = useMemo(() => {
    return new THREE.TextureLoader().load(imageSlice.user[0].img);
  }, [imageSlice.user[0].img]);

  function RoundedPlane({ width, height, radius, color }: any) {
    const shape = useMemo(() => {
      const shape = new THREE.Shape();
      const x = -width / 2;
      const y = -height / 2;

      shape.moveTo(x + radius, y);
      shape.lineTo(x + width - radius, y);
      shape.quadraticCurveTo(x + width, y, x + width, y + radius);
      shape.lineTo(x + width, y + height - radius);
      shape.quadraticCurveTo(
        x + width,
        y + height,
        x + width - radius,
        y + height
      );
      shape.lineTo(x + radius, y + height);
      shape.quadraticCurveTo(x, y + height, x, y + height - radius);
      shape.lineTo(x, y + radius);
      shape.quadraticCurveTo(x, y, x + radius, y);
      return shape;
    }, [width, height, radius]);

    return (
      <mesh>
        <shapeGeometry args={[shape]} />
        <meshBasicMaterial color={color} />
      </mesh>
    );
  }


  useFrame((state) => {
   
    const elapsed = state.clock.getElapsedTime();
    if ((ufoRef.current && !close) ) {
      ufoRef.current.position.y =
        2.5 + Math.sin(state.clock.elapsedTime * 1) * 0.1;
    }
// console.log(viewScale,'viewScale')
    if (lightRef.current && ufoRef.current.position.x == 2.2) {
      // if (lightRef.current ) {

        let lightX = viewScale < 0.20? 0.39 :viewScale < 0.24? 0.45 :viewScale <0.28? 0.55: viewScale < 0.31? 0.65 :viewScale < 0.56? 1.05 :viewScale < 0.75? 1.45:1.85
   
        lightRef.current.target.position.set(lightX, 0, 0);

      if (light) {
        lightRef.current.children[0].material.uniforms.opacity.value =
          THREE.MathUtils.lerp(
            lightRef.current.children[0].material.uniforms.opacity.value,
            1,
            0.05
          );
        lightRef.current.needsUpdate = true;
      } else {
        lightRef.current.children[0].material.uniforms.opacity.value =
          THREE.MathUtils.lerp(
            lightRef.current.children[0].material.uniforms.opacity.value,
            0,
            0.05
          );
        lightRef.current.needsUpdate = true;
      }
    }

    if (userRef.current && ufoRef.current.position.x == 2.2) {

      const posY = userRef.current.position.y;
      const targetY = 2.5;

      const speed = 0.03;
      if (Math.abs(targetY - posY) < speed) {
        userRef.current.position.y = targetY;
      } else {
        userRef.current.position.y += speed;
      }

      if (userRef.current.position.y === 2.5) {
        userRef.current.visible = false;
        lightRef.current.visible = false;
        onCloseComplete();
      }
    }

    if (close) {
      const posX = ufoRef.current.position.x;
      const targetX = 2.2;
      const speed = 0.03;

      if (Math.abs(targetX - posX) < speed) {
        ufoRef.current.position.x = targetX; // snap to target
      } else {
        ufoRef.current.position.x += targetX > posX ? speed : -speed;
      }
    }
  });

  useEffect(() => {
    if (!textType && !text) {
      setTimeout(() => {
        setSetType("details");
      }, 500);
    } else if (text) {
      setSetType(text === "stop" ? null : text);
    }

  }, [textType, text]);
  return (

    <>
     <mesh position={[0, 0, 0]}   scale={viewScale} onClick={onCloseComplete}>
      <LightRay ref={lightRef} position={[1.9, 2.5, 0.5]}  />
      <mesh position={[2, -2.7, 0]}  >
        <planeGeometry args={[10, 3, 4]} />
        <meshBasicMaterial
          map={FrameTexture || undefined}
          transparent
          opacity={1}
        />
      </mesh>
      <mesh position={[2, -0.6, 0]}   ref={userRef} >
        <planeGeometry args={[1, 2, 4]} />
        <meshBasicMaterial
          map={userTexture || undefined}
          transparent
          opacity={1}
        />
      </mesh>
      <mesh position={[5, 0.4, 0]}>
        <planeGeometry args={[5, 6, 4]} />
        <meshBasicMaterial
          map={objectTexture || undefined}
          transparent
          opacity={1}
        />
      </mesh>

      <mesh position={[3, 2.5, 0]} ref={ufoRef} >
        <planeGeometry args={[2.4, 3, 4]} />
        <meshBasicMaterial map={texture || undefined} transparent opacity={1} />
      </mesh>
      {textType && (
        <a.group position={ viewScale < 0.31? splashTextConfig[textType].mobile_position:splashTextConfig[textType].position} ref={textRef} >
          <mesh position={[0, 0, -0.01]}>
            <RoundedPlane
              width={  viewScale < 0.31? splashTextConfig[textType].mobile_width: splashTextConfig[textType].width}
              height={ viewScale < 0.31? splashTextConfig[textType].mobile_height:splashTextConfig[textType].height}
              radius={0.05}
              color="white"
            />
          </mesh>

          <>
            <Text
              fontSize={viewScale < 0.31? splashTextConfig[textType].mobile_font_size:splashTextConfig[textType].font_size}
              color="black"
              anchorY="middle"
              position={viewScale < 0.31? [0, 0, 0]:[0, 0, 0]}
            >
              { viewScale < 0.31? splashTextConfig[textType].mobile_text: splashTextConfig[textType].text}
            </Text>
          </>
        </a.group>
      )}
       </mesh>
    </>
  );
};

export default SplashAnimation;
